import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=5f09a52d"
import script from "./DataPanel.vue?vue&type=script&lang=js"
export * from "./DataPanel.vue?vue&type=script&lang=js"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=5f09a52d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports